import React from 'react';
import { StyledInput } from './styles';

const CustomInput = (props: React.InputHTMLAttributes<HTMLInputElement>) => {
  return <StyledInput {...props} />;
};

export default CustomInput;
